module.exports = __webpack_public_path__ + "img/sebrae_turismo_logo.4537b1a0.png";